/* eslint-disable
    array-callback-return,
    no-prototype-builtins,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
require('./toggle.scss');

const toggle = angular.module('bench.ui.form.toggle', []);

toggle.directive('blToggle', () => ({
  restrict: 'E',
  template(elem, attrs) {
    // set defaults
    _.defaults(attrs, {
      name: _.camelCase(attrs.name),
      type: 'checkbox',
      unchecked: 'Off',
      checked: 'On',
    });

    // attrs that go into input
    const inputAttrs = _(
      [
        'name',
        'type',
        'ng-model',
        'ng-checked',
        'checked',
        'readonly',
        'ng-readonly',
        'ng-disabled',
        'ng-change',
        'ng-click',
        'ng-true-value',
        'ng-false-value',
      ].map(attr => {
        if (attrs.hasOwnProperty(_.camelCase(attr))) {
          const attrVal = attrs[_.camelCase(attr)];
          elem.removeAttr(attr);
          if (!_.isEmpty(attrVal)) {
            return `${attr}=\"${attrVal}\"`;
          }
          return attr;
        }
      }),
    )
      .compact()
      .join('\n');

    return `\
<div class="toggle"
    id="toggle-${attrs.id}">
    <input ${inputAttrs} class="toggle_checkbox"/>
    <div class="toggle_background">
      <div class="toggle_background_unchecked toggle_background_text">
        <span>${attrs.unchecked}</span>
      </div>
      <div class="toggle_background_checked toggle_background_text">
        <span>${attrs.checked}</span>
      </div>
    </div>
    <div class="toggle_switch"></div>
</div>\
`;
  },
}));

module.exports = toggle;
